import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import AITools from "./pages/AITools";
import StockAnalyzer from "./pages/StockAnalyzer";
import Blog from "./pages/Blog";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/"                           element={<Home />} />
          <Route path="/services"                   element={<Services />} />
          <Route path="/industries"                 element={<Industries />} />
          <Route path="/ai-tools"                   element={<AITools />} />
          <Route path="/ai-tools/stock-analyzer"    element={<StockAnalyzer />} />
          <Route path="/ai-tools/finance-advisor"   element={<AITools defaultTool="finance" />} />
          <Route path="/ai-tools/tax-calculator"    element={<AITools defaultTool="tax" />} />
          <Route path="/blog"                       element={<Blog />} />
          <Route path="/careers"                    element={<Careers />} />
          <Route path="/contact"                    element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;